import {
  CONTAINER_OPTIONS,
  CONTENT_LAYOUT_OPTIONS,
  HEADING_ALIGNMENT_OPTIONS,
  MODULE_FILL_TYPE_OPTIONS,
  MODULE_FLOW_DIRECTION_OPTIONS,
  TITLE_SIZE_OPTIONS,
  TITLE_TYPE_OPTIONS,
} from '@/common/constants';
import { useModuleStyles } from '@/common/hooks';
import { BaseModuleProps } from '@/common/types';
import { HeadingBlock, HeadingBlockProps } from '@/components/blocks/HeadingBlock/HeadingBlock';
import React from 'react';

import { VideoBlock, VideoBlockProps } from '@/components/blocks/VideoBlock';
import styles from './VideoModule.module.scss';

export interface VideoModuleProps extends BaseModuleProps {
  /** Image for the Video Module */
  video?: VideoBlockProps;
}

/**
 * Video Module component
 * @param props - The props for the Video Module
 * @returns The Video Module component
 */
export const VideoModule: React.FC<VideoModuleProps> = ({
  anchorTag = undefined,
  container = CONTAINER_OPTIONS.CONTAINED,
  fillType = MODULE_FILL_TYPE_OPTIONS.BASE,
  gradientFillToken,
  layout = CONTENT_LAYOUT_OPTIONS.CONTENT_TRAILING,
  flowDirection = MODULE_FLOW_DIRECTION_OPTIONS.ROW,
  eyebrow,
  title,
  titleSize = TITLE_SIZE_OPTIONS.LARGE,
  titleType = TITLE_TYPE_OPTIONS.H2,
  bodyRichTextAsHTML,
  alignment = HEADING_ALIGNMENT_OPTIONS.START,
  ctas,
  caption,
  video,
}) => {
  const headingConfig: HeadingBlockProps = {
    eyebrow,
    title,
    titleSize,
    titleType,
    bodyRichTextAsHTML,
    alignment,
    ctas,
    caption,
  };

  // Use the common module styles hook
  const { sectionStyles, moduleBaseStyles } = useModuleStyles({
    container,
    fillType,
    gradientFillToken,
    layout,
    flowDirection,
    moduleClassName: 'module-video',
    styles,
  });

  return (
    <section className={sectionStyles} id={anchorTag}>
      <div className={moduleBaseStyles}>
        <HeadingBlock {...headingConfig} />
        {video && <VideoBlock src={video.src} title={video.title} />}
      </div>
    </section>
  );
};
